import React, { useEffect, useState } from 'react';

import cssClasses from '../Dashboard.module.css';
import {
  Box,
  Card,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import CustomAutoComplete from '../../../Subcomponents/CustomAutoComplete';
import { supabase } from '../../../supabaseClient';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import { errorTost } from '../../../Services/Toast';
import DashboardCard from '../../../Subcomponents/DashboardCard/DashboardCard';
import totalTokens from '../../../Assets/Images/Dashboard/totalTokens.svg';
import { Pie } from 'react-chartjs-2';
import User from '../../Icons/User';
import { sortBy, groupBy, maxBy, minBy, uniqBy, uniq, orderBy } from 'lodash';
import TokensVsBookingForSalesManagerDetailsModal from './TokensVsBookingForSalesManagerDetailsModal/TokensVsBookingForSalesManagerDetailsModal';
import WingWiseBookingForSalesManagerDetailsModal from './WingWiseBookingForSalesManagerDetailsModal/WingWiseBookingForSalesManagerDetailsModal';
import { TabContext, TabPanel } from '@mui/lab';
import TabsMenu from '../../../Subcomponents/TabsMenu';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useParams } from 'react-router-dom';
import { loginWithEmailPass } from '../../../Services/LoginService';
import TokenBookingCard from '../../../Subcomponents/TokenBookingCard/TokenBookingCard';

ChartJS.register(ArcElement, Tooltip, Legend);

function EventsDashboardNew({ isShowEventDropdown = false }) {
  const params = useParams();
  const rawEventName = params.eventName;
  const rawLaunchName = params.launchName;

  // URL format (multiple):
  // /BookingMISNEW/YUC-%20G1-G2,VJ%20YEN%20GH/Gudi%20Padwa,VJ%20YEN-GH-3BHK
  const urlEventNames =
    rawEventName && rawEventName.length
      ? decodeURIComponent(rawEventName)
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s)
      : [];
  const urlLaunchNames =
    rawLaunchName && rawLaunchName.length
      ? decodeURIComponent(rawLaunchName)
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s)
      : [];

  // "Multi URL mode" if comma present in either param
  const isMultiUrlMode =
    (rawEventName && rawEventName.includes(',')) ||
    (rawLaunchName && rawLaunchName.includes(','));

  const [selectedTabValue, setSelectedTabValue] = useState('Token');

  const [isLoading, setIsLoading] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(
    !isMultiUrlMode && rawEventName
      ? decodeURIComponent(rawEventName)
      : 'All'
  );
  const [selectedLaunch, setSelectedLaunch] = useState({
    label:
      !isMultiUrlMode && rawLaunchName
        ? decodeURIComponent(rawLaunchName)
        : 'All',
    value:
      !isMultiUrlMode && rawLaunchName
        ? decodeURIComponent(rawLaunchName)
        : 'All',
  });
  const [launchList, setlaunchList] = useState([]);

  const [upperCardsCounts, setUpperCardsCounts] = useState(null);

  const [arrToken, setArrToken] = useState([]);
  const [arrBooking, setArrBooking] = useState([]);

  const [firstCheckPointData, setFirstCheckPointData] = useState(null);
  const [secondCheckPointData, setSecondCheckPointData] = useState(null);

  const [
    tokensVsBookingDataForSalesManager,
    setTokensVsBookingDataForSalesManager,
  ] = useState(null);
  const [
    tokensVsBookingDataForSalesManagerForModal,
    setTokensVsBookingDataForSalesManagerForModal,
  ] = useState(null);
  const [tokensVsBookingDataForCpManager, setTokensVsBookingDataForCpManager] =
    useState(null);
  const [
    sourceWiseBookingDataForCpManager,
    setSourceWiseBookingDataForCpManager,
  ] = useState(null);

  const [wingWiseBookingData, setWingWiseBookingData] = useState(null);
  const [
    wingWiseBookingDataForSalesManagerForModal,
    setWingWiseBookingDataForSalesManagerForModal,
  ] = useState(null);
  const [floorGroupWiseBookingData, setFloorGroupWiseBookingData] =
    useState(null);
  const [seriesGroupWiseBookingData, setSeriesGroupWiseBookingData] =
    useState(null);

  // IDs derived from URL titles (multi-mode)
  const [urlEventIds, setUrlEventIds] = useState([]);
  const [urlLaunchIds, setUrlLaunchIds] = useState([]);


  const extractFloorNumber = (value) => {
  if (value == null) return 0;

  // If already number → return directly
  if (typeof value === "number") return value;

  // Extract first number from string
  const match = String(value).match(/\d+/);
  return match ? parseInt(match[0]) : 0;
};

  // ===============================
  // LOGIN + LOAD EVENTS
  // ===============================
  useEffect(() => {
    const loginAuthUser = localStorage.getItem('user');
    if (loginAuthUser) {
      getEvents();
    } else {
      loginWithEmailPass(
        process.env.REACT_APP_BOOKINGMIS_EMAIL,
        process.env.REACT_APP_BOOKINGMIS_PASSWORD
      )
        .then(() => {
          getEvents();
        })
        .catch((e) => {
          console.log('Error in login: ', e);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ===============================
  // MAIN ANALYTICS CHAIN
  // ===============================
  useEffect(() => {
    if (!eventList || eventList.length === 0) return;

    // In multi-url mode we rely on urlEventIds/urlLaunchIds
    const runChain = () => {
      getEventAnalyticsFromServer()
        .then(() => {
          return getSalesBookingEventAnalyticsFromServer();
        })
        .then(() => {
          return getCpBookingEventAnalyticsFromServer();
        })
        .then(() => {
          return getSourceWiseBookingEventAnalyticsFromServer();
        })
        .then(() => {
          return getWingWiseBookingEventAnalyticsFromServer();
        })
        .then(() => {
          dismissLoader();
          setIsLoading(false);
        })
        .catch((err) => {
          console.log('Analytics chain error => ', err);
          dismissLoader();
          setIsLoading(false);
        });
    };

    if (!isMultiUrlMode) {
      // original single-event behavior
      presentLoader();
      setIsLoading(true);
      getLaunchId()
        .then(() => {
          runChain();
        })
        .catch((err) => {
          console.log(err);
          dismissLoader();
          setIsLoading(false);
        });

      selectedEvent !== 'All' && getLaunchList();
    } else {
      // multi URL mode: urlEventIds + urlLaunchIds already computed in getEvents()
      if (urlEventIds.length === 0 && urlLaunchIds.length === 0) return;
      presentLoader();
      setIsLoading(true);
      runChain();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedEvent,
    selectedLaunch,
    eventList,
    isMultiUrlMode,
    urlEventIds,
    urlLaunchIds,
  ]);

  // ===============================
  // GET EVENTS + derive URL IDs
  // ===============================
  async function getEvents() {
    try {
      const res = await supabase
        .from('Events')
        .select('*')
        .eq('isPublished', true);
      if (res.data) {
        setEventList([...res.data]);

        // Derive eventIds from URL titles (multi or single)
        if (urlEventNames.length > 0) {
          const matchedEvents = res.data.filter((ev) =>
            urlEventNames.includes(ev?.title)
          );
          const eIds = matchedEvents.map((ev) => ev.eventId);
          setUrlEventIds(eIds);

          // Also fetch launches based on URL launch names
          if (urlLaunchNames.length > 0 && eIds.length > 0) {
            const launchRes = await supabase
              .from('Launches')
              .select('*')
              .in('eventId', eIds)
              .in('title', urlLaunchNames);
            if (launchRes.data) {
              setlaunchList(launchRes.data);
              const lIds = launchRes.data.map((l) => l.launchId);
              setUrlLaunchIds(lIds);
            }
          }
        }
      }
    } catch (err) {
      console.log('Events res error => ', err);
      errorTost('Failed to load events');
    }
  }

  // for SINGLE mode only
  async function getLaunchId() {
    try {
      if (!selectedLaunch?.label || selectedLaunch?.label === 'All') return;
      const res = await supabase
        .from('Launches')
        .select('*')
        .eq('title', selectedLaunch?.label);
      selectedLaunch.value = res?.data?.[0]?.launchId;
    } catch (err) {
      console.log(err);
    }
  }

  const getLaunchList = () => {
    const filterEvent = eventList.filter((val) => val?.title === selectedEvent);
    if (selectedLaunch?.label === 'All') {
      presentLoader();
      setIsLoading(true);
      supabase
        .from('Launches')
        .select('*')
        .eq('eventId', filterEvent[0]?.eventId)
        .then((value) => {
          supabase.from('EventTokensLaunchRelations').then((data1) => {
            const payload = [];
            value.data?.forEach((v) => {
              const _selectedLaunch = data1?.data?.find(
                (i) =>
                  i?.launchId === v?.launchId &&
                  i?.eventId === filterEvent[0]?.eventId
              );

              if (_selectedLaunch) {
                payload.push(v);
              }
            });
            setlaunchList(value?.data);
            dismissLoader();
            setIsLoading(false);
          });
        })
        .catch((err) => {
          dismissLoader();
          setIsLoading(false);
          errorTost(err.message);
        });
    }
  };

  // Helper: get effective eventIds filter for queries
  const getEventIdFilter = () => {
    if (isMultiUrlMode && urlEventIds.length > 0) return urlEventIds;
    if (selectedEvent !== 'All') {
      const _selected = eventList.find((f) => f.title === selectedEvent);
      if (_selected?.eventId) return [_selected.eventId];
    }
    return [];
  };

  // Helper: get effective launchIds filter for queries
  const getLaunchIdFilter = () => {
    if (isMultiUrlMode && urlLaunchIds.length > 0) return urlLaunchIds;
    if (selectedLaunch?.label !== 'All' && selectedLaunch?.value !== 'All') {
      return [selectedLaunch.value];
    }
    return [];
  };

  // ===============================
  // MAIN ANALYTICS FUNCTIONS
  // ===============================

  async function getEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);

    try {
      const eventIdFilter = getEventIdFilter();
      const launchIdFilter = getLaunchIdFilter();

      let query = supabase.from('EventTokensLaunchRelations').select('*');
      if (launchIdFilter.length > 0) {
        query = query.in('launchId', launchIdFilter);
      }
      let eventTokenLaunchData = await query;

      const eventTokens = eventTokenLaunchData?.data
        ?.filter((launch) => launch?.eventTokenId)
        .map((launch) => launch.eventTokenId);

      let EventTokenLeadRelationsSupabaseQuery = supabase
        .from('EventTokenLeadRelations')
        .select('*, leadId(*), eventTokenId(*, tokenId(*))');

      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, paymentId(*, eventTokenId(*, tokenId(*)))');

      if (launchIdFilter.length > 0 && eventTokens.length > 0) {
        EventTokenLeadRelationsSupabaseQuery =
          EventTokenLeadRelationsSupabaseQuery.in(
            'eventTokenId.eventTokenId',
            eventTokens
          );
        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.in(
          'paymentId.eventTokenId.eventTokenId',
          eventTokens
        );
      }

      // EVENT filter
      if (eventIdFilter.length > 0) {
        EventTokenLeadRelationsSupabaseQuery =
          EventTokenLeadRelationsSupabaseQuery.in('eventId', eventIdFilter);
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('eventId', eventIdFilter);
      }

      // LAUNCH filter again for AllotmentPayment (launchId column)
      if (launchIdFilter.length > 0) {
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('launchId', launchIdFilter);
      }

      let analysisDataResponse =
        await EventTokenLeadRelationsSupabaseQuery.eq(
          'isPrerequisiteUsed',
          false
        ).or('status.eq.active,status.eq.alloted,status.eq.adjusted');

      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed');

      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse.data.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') ||
            ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });

      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse.data.filter(
          (item) => item?.paymentId?.eventTokenId != null
        );

      analysisDataResponse.data = analysisDataResponse.data.filter(
        (item) => item?.eventTokenId != null
      );

      const groupByAnalysisDataResponseData = groupBy(
        analysisDataResponse.data,
        (item) => item?.eventTokenId?.tokenId?.name
      );
      let _arrToken = [];
      let _arrBooking = [
        {
          tokenName: 'Total Tokens',
          tokenCount: analysisDataResponse?.data?.length || 0,
          bookingName: 'Total Bookings',
          bookingCount: AllotmentPaymentSupabaseQueryResponse?.data?.length || 0,
        },
      ];

      for (const _tokenName of Object.keys(groupByAnalysisDataResponseData)) {
        _arrToken.push({
          tokenName: _tokenName,
          tokenCount:
            groupByAnalysisDataResponseData[_tokenName]?.length || 0,
          bookingName: _tokenName,
          bookingCount:
            AllotmentPaymentSupabaseQueryResponse.data?.filter(
              (item) =>
                item?.paymentId?.eventTokenId?.tokenId?.name === _tokenName
            )?.length || 0,
        });
      }

      setArrToken([..._arrToken]);
      setArrBooking([..._arrBooking]);

      if (analysisDataResponse?.data) {
        const _checkPointOneData = analysisDataResponse?.data.filter(
          (f) => f?.checkpt1
        );
        const _checkPointTwoData = analysisDataResponse?.data.filter(
          (f) => f?.checkpt1 && f?.checkpt2
        );

        const _checkPointOneGroupDataByName = groupBy(
          _checkPointOneData,
          (item) => item?.eventTokenId?.tokenId?.name
        );
        const _checkPointTwoGroupDataByName = groupBy(
          _checkPointTwoData,
          (item) => item?.eventTokenId?.tokenId?.name
        );

        const checkPointOneLabelArray1 = Object.keys(
          _checkPointOneGroupDataByName
        );
        const checkPointTwoLabelArray1 = Object.keys(
          _checkPointTwoGroupDataByName
        );

        const checkPointOneValueArray = checkPointOneLabelArray1.map(
          (m) => _checkPointOneGroupDataByName[m]?.length || 0
        );

        const checkPointOneLabelArray = checkPointOneLabelArray1.map(
          (m) => `${m} (${_checkPointOneGroupDataByName[m]?.length})` || ''
        );

        const checkPointTwoLabelArray = checkPointTwoLabelArray1.map(
          (m) => `${m} (${_checkPointTwoGroupDataByName[m]?.length})` || ''
        );

        const checkPointTwoValueArray = checkPointTwoLabelArray1.map(
          (m) => _checkPointTwoGroupDataByName[m]?.length || 0
        );

        setFirstCheckPointData({
          labels: checkPointOneLabelArray,
          datasets: [
            {
              label: 'Token Count ',
              data: checkPointOneValueArray,
              backgroundColor: backgroundColor,
              hoverOffset: 4,
            },
          ],
          totalCount: checkPointOneValueArray.reduce(
            (total, num) => total + num,
            0
          ),
        });
        setSecondCheckPointData({
          labels: checkPointTwoLabelArray,
          datasets: [
            {
              label: 'Token Count ',
              data: checkPointTwoValueArray,
              backgroundColor: backgroundColor,
              hoverOffset: 4,
            },
          ],
          totalCount: checkPointTwoValueArray.reduce(
            (total, num) => total + num,
            0
          ),
        });
      } else {
        throw analysisDataResponse;
      }
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
    }
  }

  async function getSalesBookingEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);

    try {
      const eventIdFilter = getEventIdFilter();
      const launchIdFilter = getLaunchIdFilter();

      let query = supabase.from('EventTokensLaunchRelations').select('*');
      if (launchIdFilter.length > 0) {
        query = query.in('launchId', launchIdFilter);
      }
      let eventTokenLaunchData = await query;
      const eventTokens = eventTokenLaunchData?.data
        ?.filter((launch) => launch?.eventTokenId)
        .map((launch) => launch.eventTokenId);

      let EventTokenLeadRelationsSupabaseQuery = supabase
        .from('EventTokenLeadRelations')
        .select('*, leadId(*, userId(*)), eventTokenId(*, tokenId(*))');
      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, leadId(*, userId(*)), paymentId(*, eventTokenId(*, tokenId(*)))');

      if (launchIdFilter.length > 0 && eventTokens.length > 0) {
        EventTokenLeadRelationsSupabaseQuery =
          EventTokenLeadRelationsSupabaseQuery.in(
            'eventTokenId.eventTokenId',
            eventTokens
          );
        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.in(
          'paymentId.eventTokenId.eventTokenId',
          eventTokens
        );
      }

      if (eventIdFilter.length > 0) {
        EventTokenLeadRelationsSupabaseQuery =
          EventTokenLeadRelationsSupabaseQuery.in('eventId', eventIdFilter);
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('eventId', eventIdFilter);
      }

      if (launchIdFilter.length > 0) {
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('launchId', launchIdFilter);
      }

      const EventTokenLeadRelationsSupabaseQueryResponse =
        await EventTokenLeadRelationsSupabaseQuery.eq(
          'isPrerequisiteUsed',
          false
        ).or('status.eq.active,status.eq.alloted,status.eq.adjusted');

      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed');

      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse?.data?.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') ||
            ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });

      if (AllotmentPaymentSupabaseQueryResponse?.data) {
        const filteredG1Data =
          EventTokenLeadRelationsSupabaseQueryResponse?.data?.filter(
            (item) => item?.leadId !== null && item?.eventTokenId !== null
          );

        const g1 = groupBy(
          filteredG1Data,
          (item) => item?.leadId?.userId?.name
        );

        const filteredG2Data =
          AllotmentPaymentSupabaseQueryResponse?.data?.filter(
            (item) => item?.leadId !== null && item?.eventTokenId !== null
          );

        const g2 = groupBy(
          filteredG2Data,
          (item) => item?.leadId?.userId?.name
        );

        let objCreate = {};
        Array(...new Set([...Object.keys(g1), ...Object.keys(g2)])).forEach(
          (keyElement) => {
            let arr = [];
            if (g1[keyElement]) {
              arr = [...arr, ...g1[keyElement]];
            }
            if (g2[keyElement]) {
              arr = [...arr, ...g2[keyElement]];
            }
            objCreate[keyElement] = arr;
          }
        );

        const val = Object.keys(objCreate).reduce((res, cr) => {
          res.push({
            name: cr,
            ar: objCreate[cr],
            tokenArr: objCreate[cr]?.filter((f) => !f.allotmentPaymentId)
              .length,
          });
          return res;
        }, []);

        const payload = sortBy(val, (e) => e.tokenArr, ['desc']);
        setTokensVsBookingDataForSalesManager(payload);
      } else {
        throw AllotmentPaymentSupabaseQueryResponse;
      }
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
    }
  }

  async function getCpBookingEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);
    try {
      const eventIdFilter = getEventIdFilter();
      const launchIdFilter = getLaunchIdFilter();

      let query = supabase.from('EventTokensLaunchRelations').select('*');
      if (launchIdFilter.length > 0) {
        query = query.in('launchId', launchIdFilter);
      }
      let eventTokenLaunchData = await query;
      const eventTokens = eventTokenLaunchData?.data
        ?.filter((launch) => launch?.eventTokenId)
        .map((launch) => launch.eventTokenId);

      let EventTokenLeadRelationsSupabaseQuery = supabase
        .from('EventTokenLeadRelations')
        .select('*, leadId(*, cpId(*)), eventTokenId(*, tokenId(*))');
      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, leadId(*, cpId(*)), paymentId(*, eventTokenId(*, tokenId(*)))');

      if (launchIdFilter.length > 0 && eventTokens.length > 0) {
        EventTokenLeadRelationsSupabaseQuery =
          EventTokenLeadRelationsSupabaseQuery.in(
            'eventTokenId.eventTokenId',
            eventTokens
          );
        AllotmentPaymentSupabaseQuery = AllotmentPaymentSupabaseQuery.in(
          'paymentId.eventTokenId.eventTokenId',
          eventTokens
        );
      }

      if (eventIdFilter.length > 0) {
        EventTokenLeadRelationsSupabaseQuery =
          EventTokenLeadRelationsSupabaseQuery.in('eventId', eventIdFilter);
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('eventId', eventIdFilter);
      }

      if (launchIdFilter.length > 0) {
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('launchId', launchIdFilter);
      }

      const EventTokenLeadRelationsSupabaseQueryResponse =
        await EventTokenLeadRelationsSupabaseQuery.eq(
          'isPrerequisiteUsed',
          false
        )
          .or('status.eq.active,status.eq.alloted,status.eq.adjusted')
          .not('leadId', 'is', null)
          .not('leadId.cpId', 'is', null);

      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed')
          .not('leadId', 'is', null)
          .not('leadId.cpId', 'is', null);

      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse.data.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') ||
            ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });

      if (AllotmentPaymentSupabaseQueryResponse?.data) {
        const g1 = groupBy(
          EventTokenLeadRelationsSupabaseQueryResponse?.data?.filter(
            (f) => f?.leadId && f?.eventTokenId !== null
          ),
          (item) => item?.leadId?.cpId?.billingName
        );
        const g2 = groupBy(
          AllotmentPaymentSupabaseQueryResponse?.data?.filter(
            (f) =>
              f?.leadId &&
              f?.leadId?.cpId &&
              f?.paymentId?.eventTokenId !== null
          ),
          (item) => item?.leadId?.cpId?.billingName
        );

        let objCreate = {};
        Array(...new Set([...Object.keys(g1), ...Object.keys(g2)])).forEach(
          (keyElement) => {
            let arr = [];
            if (g1[keyElement]) {
              arr = [...arr, ...g1[keyElement]];
            }
            if (g2[keyElement]) {
              arr = [...arr, ...g2[keyElement]];
            }
            objCreate[keyElement] = arr;
          }
        );

        const val = Object.keys(objCreate).reduce((res, cr) => {
          res.push({
            name: cr,
            ar: objCreate[cr],
            tokenArr: objCreate[cr].filter((f) => !f.allotmentPaymentId)
              .length,
          });
          return res;
        }, []);

        const payload = sortBy(val, (e) => e.tokenArr, ['desc']);

        setTokensVsBookingDataForCpManager(payload);
      } else {
        throw AllotmentPaymentSupabaseQueryResponse;
      }
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
    }
  }

  async function getSourceWiseBookingEventAnalyticsFromServer() {
    presentLoader();
    setIsLoading(true);

    try {
      const eventIdFilter = getEventIdFilter();
      const launchIdFilter = getLaunchIdFilter();
      let AllotmentPaymentSupabaseQuery = supabase
        .from('AllotmentPayment')
        .select('*, leadId(*, userId(*)), paymentId(*, eventTokenId(*, tokenId(*)))');

      if (eventIdFilter.length > 0) {
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('eventId', eventIdFilter);
      }

      if (launchIdFilter.length > 0) {
        AllotmentPaymentSupabaseQuery =
          AllotmentPaymentSupabaseQuery.in('launchId', launchIdFilter);
      }

      const AllotmentPaymentSupabaseQueryResponse =
        await AllotmentPaymentSupabaseQuery.in('pricingType', [
          'event',
          'preselect',
        ])
          .neq('status', 'Released')
          .neq('status', 'Cancelled')
          .not('leadId', 'is', null)
          .neq('status', 'On Hold')
          .neq('status', 'Refund Initiated')
          .neq('status', 'Refund Processed');

      AllotmentPaymentSupabaseQueryResponse.data =
        AllotmentPaymentSupabaseQueryResponse?.data?.filter((ele) => {
          if (
            (ele.pricingType === 'preselect' &&
              ele.preselectConfirmation === 'confirmed') ||
            ele.pricingType === 'event'
          ) {
            return true;
          } else {
            return false;
          }
        });

      if (AllotmentPaymentSupabaseQueryResponse?.data) {
        const g2 = groupBy(
          AllotmentPaymentSupabaseQueryResponse?.data?.filter(
            (f) => f?.leadId && f?.paymentId?.eventTokenId !== null
          ),
          (item) => item?.leadId?.userId?.name
        );

        const orderbySalesName = orderBy(Object.keys(g2));

        const sortedObject = orderbySalesName.reduce((acc, key) => {
          acc[key] = g2[key];
          return acc;
        }, {});

        setSourceWiseBookingDataForCpManager(sortedObject);
      } else {
        throw AllotmentPaymentSupabaseQueryResponse;
      }
    } catch (error) {
      console.log('analysisDataResponse error => ', error);
      if (error?.error?.message) {
        errorTost(error?.error?.message);
      } else {
        errorTost('Something went wrong! Try again');
      }
    }
  }

async function getWingWiseBookingEventAnalyticsFromServer() {
  presentLoader();
  setIsLoading(true);

  try {
    // Get selected filters
    const eventIdFilter = getEventIdFilter(); 
    const launchIdFilter = getLaunchIdFilter();

    let finalLaunchIds = [];

    // ---------------------------------------------------------
    // STEP 1: If event filter exists, fetch launchIds for event
    // ---------------------------------------------------------
    if (eventIdFilter.length > 0) {
      const launchRes = await supabase
        .from("Launches")
        .select("launchId, eventId")
        .in("eventId", eventIdFilter);

      if (launchRes.error) throw launchRes.error;

      finalLaunchIds = launchRes.data.map((x) => x.launchId);
    }

    // ---------------------------------------------------------
    // STEP 2: Merge with launch filter from dropdown
    // ---------------------------------------------------------
    if (launchIdFilter.length > 0) {
      if (finalLaunchIds.length > 0) {
        // intersection
        finalLaunchIds = finalLaunchIds.filter((id) =>
          launchIdFilter.includes(id)
        );
      } else {
        finalLaunchIds = [...launchIdFilter];
      }
    }

    // If still empty → nothing to query
    if (finalLaunchIds.length === 0) {
      console.warn("No launchIds matched filter.");
      setWingWiseBookingData({});
      setFloorGroupWiseBookingData({});
      setSeriesGroupWiseBookingData({});
      dismissLoader();
      setIsLoading(false);
      return;
    }

    // ---------------------------------------------------------
    // STEP 3: MAIN QUERY – NOW SAFE & FAST
    // ---------------------------------------------------------

    const selectQuery = `
      *,
      launchId(*),
      unitId(
        *,
        AllotmentPayment!left(*),
        ProjectInventoryRelations!left(*),
        leadId(*, userId(*)),
        wingId(*),
        inventoryStatusId(*),
        inventoryTypeId(*)
      )
    `;

    const invRes = await supabase
      .from("LaunchInventoryRelations")
      .select(selectQuery)
      .in("launchId", finalLaunchIds);

    if (invRes.error) throw invRes.error;

    let rows = invRes.data || [];

    // ---------------------------------------------------------
    // STEP 4: FILTER rows same as your original logic
    // ---------------------------------------------------------

    rows = rows.filter(
      (ele) =>
        ele?.unitId?.ProjectInventoryRelations?.length > 0 &&
        ele?.launchId
    );

    const uniqByUnitId = uniqBy(rows, (item) => item?.unitId?.unitId);

    const filteredDataOnAllotment = uniqByUnitId.filter((allotment) => {
      const pay = allotment?.unitId?.AllotmentPayment;
      if (pay?.length > 0) {
        const sorted = pay
          .filter((p) => p.created_at)
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        const latest = sorted[0];

        if (!latest) return true;

        if (
          ["Released", "Cancelled", "On Hold", "Refund Initiated", "Refund Processed"]
            .includes(latest.status)
        ) {
          return false;
        }

        if (
          (latest.pricingType === "preselect" &&
            latest.preselectConfirmation === "confirmed") ||
          latest.pricingType === "event"
        ) {
          return true;
        }

        return false;
      }

      return true;
    });

    // ---------------------------------------------------------
    // STEP 5: Wing grouping
    // ---------------------------------------------------------
    const g1 = groupBy(
      filteredDataOnAllotment,
      (item) => item?.unitId?.wingId?.wingId
    );
    setWingWiseBookingData(g1);

    // ---------------------------------------------------------
    // STEP 6: Floor grouping
    // ---------------------------------------------------------
const g2 = groupBy(
  filteredDataOnAllotment,
  (item) => item?.unitId?.floorNo
);

let _obj = {
  Lower: { arr: [] },
  Middle: { arr: [] },
  Upper: { arr: [] },
};

Object.keys(g2).forEach((floorKey) => {
  const floorNum = extractFloorNumber(floorKey);

  if (floorNum <= 4) {
    _obj.Lower.arr.push(...g2[floorKey]);
  } else if (floorNum <= 18) {
    _obj.Middle.arr.push(...g2[floorKey]);
  } else {
    _obj.Upper.arr.push(...g2[floorKey]);
  }
});

_obj.Upper.min = minBy(_obj.Upper.arr, (i) => extractFloorNumber(i?.unitId?.floorNo))?.unitId?.floorNo;
_obj.Upper.max = maxBy(_obj.Upper.arr, (i) => extractFloorNumber(i?.unitId?.floorNo))?.unitId?.floorNo;

_obj.Middle.min = minBy(_obj.Middle.arr, (i) => extractFloorNumber(i?.unitId?.floorNo))?.unitId?.floorNo;
_obj.Middle.max = maxBy(_obj.Middle.arr, (i) => extractFloorNumber(i?.unitId?.floorNo))?.unitId?.floorNo;

_obj.Lower.min = minBy(_obj.Lower.arr, (i) => extractFloorNumber(i?.unitId?.floorNo))?.unitId?.floorNo;
_obj.Lower.max = maxBy(_obj.Lower.arr, (i) => extractFloorNumber(i?.unitId?.floorNo))?.unitId?.floorNo;

setFloorGroupWiseBookingData(_obj);

    // ---------------------------------------------------------
    // STEP 7: Series grouping
    // ---------------------------------------------------------
    const g3 = groupBy(filteredDataOnAllotment, (item) => {
      const unitNo = item?.unitId?.unitNo ?? "";
      const two = unitNo.slice(-2);
      let mod = /\D/.test(unitNo) ? Number(two) % 10 : Number(unitNo) % 10;
      return mod === 0 ? 10 : mod;
    });

    const labels = uniq(
      filteredDataOnAllotment.map((m) => {
        const unitNo = m?.unitId?.unitNo ?? "";
        const two = unitNo.slice(-2);
        let mod = /\D/.test(unitNo) ? Number(two) % 10 : Number(unitNo) % 10;
        return mod === 0 ? 10 : mod;
      })
    ).sort((a, b) => a - b);

    let _objForSeries = {};
    labels.forEach((lb) => {
      _objForSeries[lb] = g3[lb] ?? [];
    });

    setSeriesGroupWiseBookingData(_objForSeries);

    dismissLoader();
    setIsLoading(false);

  } catch (error) {
    console.error("Wing analytics error => ", error);
    errorTost(error?.message || "Something went wrong!");
  }
}




  return (
    <>
      <div>
        <Box className={cssClasses.TabsWrapper} style={{ height: '100%' }}>
          <TabContext value={selectedTabValue}>
            <div className={cssClasses.dropDownWrapper}>
              <TabsMenu
                selectedColor={'#1570EF'}
                selectedBackgroundColor={'#FFFFFF'}
                stylesForTab={{
                  color: '#344054',
                  fontSize: '1.6rem',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: '2.4rem',
                  padding: '0.8rem 1.2rem',
                  textTransform: 'unset',
                  borderBottom: '1px solid #EAECF0',
                }}
                borderColor={'#1570EFs'}
                stylesForWrapper={{
                  padding: '1.5rem 0',
                  background: '#FFFFFF',
                }}
                list={tabList}
                value={selectedTabValue}
                handleChange={(e, value) => {
                  setSelectedTabValue(value);
                }}
              />
              <Box>
                {isShowEventDropdown && (
                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2rem',
                        width: '100%',
                      }}
                    >
                      <p style={{ fontSize: '2rem' }}>Events&nbsp;:</p>
                      <div style={{ width: '25rem' }}>
                        <CustomAutoComplete
                          NoOptionsText={'No events found'}
                          InitialValue={(e) => {
                            setSelectedEvent(e || 'All');
                            setSelectedLaunch({
                              label: 'All',
                              value: 'All',
                            });
                          }}
                          list={['All', ...eventList.map((m) => m?.title)]}
                          multiple={false}
                          disable={false}
                          value={selectedEvent}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* When URL has multiple events/launches, show them info */}
                {isMultiUrlMode && (
                  <div style={{ marginTop: '1rem' }}>
                    <Typography
                      fontSize={'1.4rem'}
                      color="#667085"
                      style={{ whiteSpace: 'pre-line' }}
                    >
                      <b>URL Events:</b> {urlEventNames.join(', ') || 'All'}
                      {'\n'}
                      <b>URL Launches:</b> {urlLaunchNames.join(', ') || 'All'}
                    </Typography>
                  </div>
                )}

                {!isMultiUrlMode && selectedEvent !== 'All' && !rawLaunchName && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '2rem',
                      width: '100%',
                    }}
                  >
                    <p style={{ fontSize: '2rem' }}>Launches&nbsp;:</p>
                    <div style={{ width: '23rem' }}>
                      <CustomAutoComplete
                        NoOptionsText={'No launch found'}
                        InitialValue={(e) => {
                          setSelectedLaunch({
                            label: e?.label || 'All',
                            value: e?.value || 'All',
                          });
                        }}
                        list={
                          launchList
                            ? [
                                { label: 'All', value: 'All' },
                                ...launchList.map((m) => ({
                                  label: m?.title,
                                  value: m?.launchId,
                                })),
                              ]
                            : []
                        }
                        multiple={false}
                        disable={false}
                        value={selectedLaunch}
                      />
                    </div>
                  </div>
                )}
              </Box>
            </div>

            <TabPanel
              style={{
                height: 'calc(100% - 10rem)',
                padding: '0rem !important',
              }}
              className={cssClasses.Tabs}
              value={'Token'}
              index={0}
            >
              <div className={cssClasses.totalCountsDiv}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p
                    style={{ marginTop: '2rem' }}
                    className={cssClasses.countsHeader}
                  >
                    Tokens
                  </p>
                  <p
                    style={{ marginTop: '2rem' }}
                    className={cssClasses.countsHeader}
                  >
                    {`(Total Tokens: ${
                      arrBooking?.[0]?.tokenCount
                        ? arrBooking?.[0]?.tokenCount
                        : 0
                    } :: Tokens Booked: ${
                      arrBooking?.[0]?.bookingCount
                        ? arrBooking?.[0]?.bookingCount
                        : 0
                    })`}
                  </p>
                </div>
                <Grid
                  container
                  spacing={{ xs: 2, md: 3, lg: 3 }}
                  columns={{ xs: 4, sm: 12, md: 12, lg: 20 }}
                >
                  {orderBy(
                    arrToken,
                    [(token) => token.tokenName.toLowerCase()],
                    ['asc']
                  ).map((arrTokenItem) => (
                    <Grid
                      key={arrTokenItem?.tokenName}
                      className={cssClasses.Grid}
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      lg={4}
                    >
                      <TokenBookingCard
                        icon={totalTokens}
                        tokenNumber={arrTokenItem?.tokenCount}
                        tokenTitle={arrTokenItem?.tokenName}
                        bookingNumber={arrTokenItem?.bookingCount}
                      />
                    </Grid>
                  ))}
                </Grid>

                <Divider style={{ margin: '3rem 0' }} />

                <Box className={cssClasses.bookingTableCardWrapper}>
                  <Card
                    style={{ padding: '2.4rem' }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={'#FFFF'} fill={'#1570EF'} />
                      <p>Tokens Vs Booking (Sales Manager)</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sales&nbsp;Manager</TableCell>
                            <TableCell align="right">Token</TableCell>
                            <TableCell align="right">Booking</TableCell>
                            <TableCell align="right">
                              Total&nbsp;Sales
                            </TableCell>
                            <TableCell align="right">
                              Action&nbsp;&nbsp;
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tokensVsBookingDataForSalesManager &&
                            Object.keys(tokensVsBookingDataForSalesManager)
                              .reverse()
                              .map((salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {
                                      tokensVsBookingDataForSalesManager[
                                        salesNameKey
                                      ]?.name
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => !f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right" width={'15rem'}>
                                    ₹{' '}
                                    {numDifferentiation(
                                      tokensVsBookingDataForSalesManager[
                                        salesNameKey
                                      ]?.ar
                                        .filter((f) => f?.allotmentPaymentId)
                                        ?.map((item) => item?.unitCost?.bsp)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography
                                      color={'#1570EF'}
                                      fontSize={'1.6rem'}
                                      textAlign={'right'}
                                      style={{ cursor: 'pointer' }}
                                      width={'10rem'}
                                      onClick={() => {
                                        setTokensVsBookingDataForSalesManagerForModal(
                                          tokensVsBookingDataForSalesManager[
                                            salesNameKey
                                          ].ar
                                        );
                                      }}
                                    >
                                      View Details
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>

                  <Card
                    style={{ padding: '2.4rem' }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={'#FFFF'} fill={'#1570EF'} />
                      <p>Tokens VS Booking (CP)</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Token</TableCell>
                            <TableCell align="right">Booking</TableCell>
                            <TableCell align="right" width={'15rem'}>
                              Total&nbsp;Sales
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tokensVsBookingDataForCpManager &&
                            Object.keys(tokensVsBookingDataForCpManager)
                              .reverse()
                              .map((salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {
                                      tokensVsBookingDataForCpManager[
                                        salesNameKey
                                      ]?.name
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForCpManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => !f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForCpManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right" width={'15rem'}>
                                    ₹{' '}
                                    {numDifferentiation(
                                      tokensVsBookingDataForCpManager[
                                        salesNameKey
                                      ]?.ar
                                        .filter((f) => f?.allotmentPaymentId)
                                        ?.map((item) => item?.unitCost?.bsp)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>

                  <Card
                    style={{ padding: '2.4rem' }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={'#FFFF'} fill={'#1570EF'} />
                      <p>Source Wise Booking</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sales&nbsp;Manager</TableCell>
                            <TableCell align="right">CP</TableCell>
                            <TableCell align="right">Walk In</TableCell>
                            <TableCell align="right">R & L</TableCell>
                            <TableCell align="right">Total Booking</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {sourceWiseBookingDataForCpManager &&
                            Object.keys(sourceWiseBookingDataForCpManager).map(
                              (salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {salesNameKey}
                                  </TableCell>
                                  <TableCell align="right">
                                    {sourceWiseBookingDataForCpManager[
                                      salesNameKey
                                    ]?.filter(
                                      (f) => f?.leadId?.leadType === 'CP'
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {sourceWiseBookingDataForCpManager[
                                      salesNameKey
                                    ]?.filter(
                                      (f) => f?.leadId?.leadType === 'Direct'
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {sourceWiseBookingDataForCpManager[
                                      salesNameKey
                                    ]?.filter(
                                      (f) => f?.leadId?.leadType === 'R&L'
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {(
                                      (sourceWiseBookingDataForCpManager[
                                        salesNameKey
                                      ]?.filter(
                                        (f) => f?.leadId?.leadType === 'CP'
                                      )?.length || 0) +
                                      (sourceWiseBookingDataForCpManager[
                                        salesNameKey
                                      ]?.filter(
                                        (f) => f?.leadId?.leadType === 'Direct'
                                      )?.length || 0) +
                                      (sourceWiseBookingDataForCpManager[
                                        salesNameKey
                                      ]?.filter(
                                        (f) => f?.leadId?.leadType === 'R&L'
                                      )?.length || 0)
                                    ).toString()}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{' '}
                                    {numDifferentiation(
                                      sourceWiseBookingDataForCpManager[
                                        salesNameKey
                                      ]
                                        ?.filter((f) => f?.allotmentPaymentId)
                                        ?.map((item) => item?.unitCost?.bsp)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>

                  <Card
                    style={{ padding: '2.4rem' }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={'#FFFF'} fill={'#1570EF'} />
                      <p>Wing Wise Data</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Wing</TableCell>
                            <TableCell align="right">Available</TableCell>
                            <TableCell align="right">Sold</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                            <TableCell align="right">Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {wingWiseBookingData &&
                            Object.keys(wingWiseBookingData).map(
                              (wingNameKey) => (
                                <TableRow
                                  key={wingNameKey}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {
                                      wingWiseBookingData[wingNameKey][0]
                                        ?.unitId?.wingId?.wingName
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {wingWiseBookingData[wingNameKey]?.filter(
                                      (f) =>
                                        ['On Hold', 'Available'].some(
                                          (s) =>
                                            s ===
                                            f?.unitId?.inventoryStatusId
                                              ?.status
                                        )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {wingWiseBookingData[wingNameKey]?.filter(
                                      (f) =>
                                        [
                                          'Sold',
                                          'Payment Pending',
                                          'Kyc Pending',
                                          'Kyc Done',
                                        ].some(
                                          (s) =>
                                            s ===
                                            f?.unitId?.inventoryStatusId
                                              ?.status
                                        )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{' '}
                                    {numDifferentiation(
                                      wingWiseBookingData[wingNameKey]
                                        ?.filter((f) =>
                                          [
                                            'Sold',
                                            'Payment Pending',
                                            'Kyc Pending',
                                            'Kyc Done',
                                          ].some(
                                            (s) =>
                                              s ===
                                              f?.unitId?.inventoryStatusId
                                                ?.status
                                          )
                                        )
                                        ?.map((item) => item?.unitId?.BSP)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                  <TableCell align="right">
                                    <Typography
                                      color={'#1570EF'}
                                      fontSize={'1.6rem'}
                                      textAlign={'right'}
                                      style={{ cursor: 'pointer' }}
                                      onClick={() => {
                                        setWingWiseBookingDataForSalesManagerForModal(
                                          wingWiseBookingData[wingNameKey]
                                        );
                                      }}
                                    >
                                      View Details
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>

                  <Card
                    style={{ padding: '2.4rem' }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={'#FFFF'} fill={'#1570EF'} />
                      <p>Group wise Data</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Category</TableCell>
                            <TableCell align="right">Available</TableCell>
                            <TableCell align="right">Sold</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {floorGroupWiseBookingData &&
                            Object.keys(floorGroupWiseBookingData).map(
                              (floorNameKey) => (
                                <TableRow
                                  key={floorNameKey}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {floorNameKey}
                                  </TableCell>
                                  <TableCell align="right">
                                    {floorGroupWiseBookingData[
                                      floorNameKey
                                    ]?.arr?.filter((f) =>
                                      ['On Hold', 'Available'].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {floorGroupWiseBookingData[
                                      floorNameKey
                                    ]?.arr?.filter((f) =>
                                      [
                                        'Sold',
                                        'Payment Pending',
                                        'Kyc Pending',
                                        'Kyc Done',
                                      ].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{' '}
                                    {numDifferentiation(
                                      floorGroupWiseBookingData[
                                        floorNameKey
                                      ]?.arr
                                        ?.filter((f) =>
                                          [
                                            'Sold',
                                            'Payment Pending',
                                            'Kyc Pending',
                                            'Kyc Done',
                                          ].some(
                                            (s) =>
                                              s ===
                                              f?.unitId?.inventoryStatusId
                                                ?.status
                                          )
                                        )
                                        ?.map((item) => item?.unitId?.BSP)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>

                  <Card
                    style={{ padding: '2.4rem' }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={'#FFFF'} fill={'#1570EF'} />
                      <p>Series wise Data</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Series</TableCell>
                            <TableCell align="right">Available</TableCell>
                            <TableCell align="right">Sold</TableCell>
                            <TableCell align="right">Total Sales</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {seriesGroupWiseBookingData &&
                            Object.keys(seriesGroupWiseBookingData)
                              .sort((a, b) => a - b)
                              .map((seriesNameKey) => (
                                <TableRow
                                  key={seriesNameKey}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    #{seriesNameKey}
                                  </TableCell>
                                  <TableCell align="right">
                                    {seriesGroupWiseBookingData[
                                      seriesNameKey
                                    ]?.filter((f) =>
                                      ['On Hold', 'Available'].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {seriesGroupWiseBookingData[
                                      seriesNameKey
                                    ]?.filter((f) =>
                                      [
                                        'Sold',
                                        'Payment Pending',
                                        'Kyc Pending',
                                        'Kyc Done',
                                      ].some(
                                        (s) =>
                                          s ===
                                          f?.unitId?.inventoryStatusId?.status
                                      )
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    ₹{' '}
                                    {numDifferentiation(
                                      seriesGroupWiseBookingData[seriesNameKey]
                                        ?.filter((f) =>
                                          [
                                            'Sold',
                                            'Payment Pending',
                                            'Kyc Pending',
                                            'Kyc Done',
                                          ].some(
                                            (s) =>
                                              s ===
                                              f?.unitId?.inventoryStatusId
                                                ?.status
                                          )
                                        )
                                        ?.map((item) => item?.unitId?.BSP)
                                        ?.reduce(
                                          (prev, next) => prev + next,
                                          0
                                        ) || 0
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </Box>
              </div>
            </TabPanel>

            <TabPanel
              style={{
                height: 'calc(100% - 10rem)',
                padding: '0rem !important',
              }}
              className={cssClasses.Tabs}
              value={'Attendance'}
              index={1}
            >
              <div className={cssClasses.totalCountsDiv}>
                <Box className={cssClasses.checkPointCardWrapper}>
                  {firstCheckPointData && (
                    <Card>
                      <Typography
                        color={'#374151'}
                        fontSize={'2.4rem'}
                        lineHeight={'3rem'}
                        fontWeight={700}
                        mb={'2rem'}
                        textAlign={'center'}
                      >
                        First Checkpoint - {firstCheckPointData?.totalCount}
                      </Typography>
                      <Box className={cssClasses.pieChatContainer}>
                        <Pie
                          data={firstCheckPointData}
                          options={{
                            responsive: true,
                            plugins: {
                              legend: {
                                position: 'right',
                              },
                            },
                          }}
                        />
                      </Box>
                    </Card>
                  )}
                  {secondCheckPointData && (
                    <Card>
                      <Typography
                        color={'#374151'}
                        fontSize={'2.4rem'}
                        lineHeight={'3rem'}
                        fontWeight={700}
                        mb={'2rem'}
                        textAlign={'center'}
                      >
                        Second Checkpoint - {secondCheckPointData?.totalCount}
                      </Typography>
                      <Box className={cssClasses.pieChatContainer}>
                        <Pie
                          data={secondCheckPointData}
                          options={{
                            responsive: true,
                            plugins: {
                              legend: {
                                position: 'right',
                              },
                            },
                          }}
                        />
                      </Box>
                    </Card>
                  )}
                </Box>
                <Divider style={{ margin: '3rem 0' }} />

                <Box>
                  <Card
                    style={{ padding: '2.4rem' }}
                    className={cssClasses.cardCss}
                  >
                    <div className={cssClasses.cardHeader}>
                      <User color={'#FFFF'} fill={'#1570EF'} />
                      <p>Tokens (Sales Manager)</p>
                    </div>
                    <TableContainer>
                      <Table stickyHeader sx={[tableStyle]}>
                        <TableHead>
                          <TableRow>
                            <TableCell>Sales&nbsp;Manager</TableCell>
                            <TableCell
                              align="right"
                              className={cssClasses.headingFont}
                            >
                              Total Count
                            </TableCell>
                            <TableCell
                              align="right"
                              className={cssClasses.headingFont}
                            >
                              Check Point 1
                            </TableCell>
                            <TableCell
                              align="right"
                              className={cssClasses.headingFont}
                            >
                              Check Point 2
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tokensVsBookingDataForSalesManager &&
                            Object.keys(tokensVsBookingDataForSalesManager)
                              .reverse()
                              .map((salesNameKey) => (
                                <TableRow
                                  key={salesNameKey}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {
                                      tokensVsBookingDataForSalesManager[
                                        salesNameKey
                                      ]?.name
                                    }
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => !f?.allotmentPaymentId)
                                      ?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter(
                                      (f) =>
                                        f?.checkpt1 === true &&
                                        f?.checkpt2 === false
                                    )?.length || 0}
                                  </TableCell>
                                  <TableCell align="right">
                                    {tokensVsBookingDataForSalesManager[
                                      salesNameKey
                                    ]?.ar.filter((f) => f?.checkpt2 === true)
                                      ?.length || 0}
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </Box>
              </div>
            </TabPanel>
          </TabContext>
        </Box>
      </div>

      {tokensVsBookingDataForSalesManagerForModal && (
        <TokensVsBookingForSalesManagerDetailsModal
          open={true}
          handleClose={() => {
            setTokensVsBookingDataForSalesManagerForModal(null);
          }}
          tokensVsBookingDataForSalesManagerForModal={
            tokensVsBookingDataForSalesManagerForModal
          }
        />
      )}

      {wingWiseBookingDataForSalesManagerForModal && (
        <WingWiseBookingForSalesManagerDetailsModal
          open={true}
          handleClose={() => {
            setWingWiseBookingDataForSalesManagerForModal(null);
          }}
          wingWiseBookingDataForSalesManagerForModal={
            wingWiseBookingDataForSalesManagerForModal
          }
        />
      )}
    </>
  );
}

export default EventsDashboardNew;

const tableStyle = {
  ' .MuiTableCell-root': {
    fontSize: '1.6rem',
  },
};

const tabList = [
  {
    text: 'Tokens & Bookings',
    value: 'Token',
    key: 0,
  },
  {
    text: 'Attendance',
    value: 'Attendance',
    key: 1,
  },
];
const backgroundColor = [
  'rgb(255, 99, 132)',
  'rgb(54, 162, 235)',
  'rgb(255, 205, 86)',
  'rgb(192,192,192)',
  'rgb(128,0,0)',
  'rgb(0,139,139)',
  'rgb(153,50,204)',
  'rgb(47,79,79)',
  'rgb(178,34,34)',
  'rgb(205,92,92)',
  'rgb(240,230,140)',
  'rgb(240,128,128)',
  'rgb(32,178,170)',
  'rgb(64,224,208)',
  'rgb(154,205,50)',
];
function numDifferentiation(value) {
  const val = Math.abs(value);
  if (val >= 10000000) return `${(value / 10000000).toFixed(2)} Cr`;
  if (val >= 100000) return `${(value / 100000).toFixed(2)} Lac`;
  return value;
}
